class CCModalSE {
  static modal;
  static closeModalElements;
  static approvalModal;
  static approvalModalContent;
  static approvalModalCloseElements;
  static RemoveEditors;
  static CreateEditor;

  static async init() {
    return new Promise(async (resolve, reject) => {
      try {
        await CCModalSE._searchElementTimer(".cc-modal-se").then((modalElement) => {
          CCModalSE.modal = modalElement;
          if (!CCModalSE.modal) throw new Error("Modal with SE not found");
        });
        await CCModalSE._searchElementTimer(".close-modal-action").then(() => {
          CCModalSE.closeModalElements = Array.from(document.querySelectorAll(".close-modal-action"));
          CCModalSE.closeModalElements.forEach(element => element.addEventListener("click", CCModalSE._approvalShow));
        });
        await CCModalSE._searchElementTimer(".cc-modal").then((approvalModal) => {
          CCModalSE.approvalModal = approvalModal;
          if (!CCModalSE.approvalModal) throw new Error("Approval modal not found");
          CCModalSE.approvalModalContent = approvalModal.querySelector(".cc-modal--fill_cart")
          CCModalSE.approvalModalCloseElements = Array.from(approvalModal.querySelectorAll(".cc-modal--close-action"));
          CCModalSE.approvalModalCloseElements.forEach(element => element.addEventListener("click", CCModalSE._approvalHide));
          CCModalSE.approvalModalContent.querySelector("#cc-modal--agree").addEventListener("click", CCModalSE._finish);
        });
        resolve(true);
      } catch (error) {
        console.error(error);
        reject(new Error('Error initializing CCModalSE'));
      }
    })
  }

  /**
   * Set methods for management editor
   * public method
   * @param { RemoveEditors: () => void, CreateEditor: () => void } methods 
   */
  static setEditorMethods(methods) {
    CCModalSE.RemoveEditors = methods?.RemoveEditors;
    CCModalSE.CreateEditor = methods?.CreateEditor;
  }

  /**
   * Open popup with editor
   * public method
   */
  static show() {
    CCModalSE.modal.style.display = "block";
  }

  /**
   * Hide popup with editor
   * public method
   */
  static hide() {
    CCModalSE.modal.style.display = "none";
  }

  /**
   * Open popup with confirmation to close popup with editor
   * private method
   */
  static _approvalShow() {
    CCModalSE.approvalModal.style.display = "flex";
    CCModalSE.approvalModalContent.style.display = "block";
  }

  /**
   * Hide popup with confirmation of closing popup with editor
   * private method
   */
  static _approvalHide() {
    CCModalSE.approvalModal.style.display = "none";
    CCModalSE.approvalModalContent.style.display = "none";
  }


  static _finish() {
    CCModalSE._approvalHide();
    CCModalSE.hide();
    CCModalSE.RemoveEditors();
    CCModalSE.CreateEditor();
  }

  /**
   * Asynchronous DOM element search
   * private method
   */
  static _searchElementTimer(selector) {
    return new Promise((resolve, reject) => {
      const timerQ = setInterval(() => {
        const searchQuery = document.querySelector(selector);
        if (!!searchQuery) {
          clearInterval(timerQ);
          return resolve(searchQuery);
        } else {
          return reject(new Error(`Element not found: ${selector}`));
        }
      }, 500);
      setTimeout(() => (!!timerQ ? clearInterval(timerQ) : false), 100000);
    });
  }
}
window.CCModalSE = CCModalSE;

